// Partitions
import * as _ from "lodash"
import {Schema} from "js-data";
import * as PASchema from "./PAdbSchema";
import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default,

} from "./PAdbSchema";



// PEA Portfolio
export const WB_Event_Portfolio = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_Portfolio', // optional
    description: 'Schema for WB_Evt_Portfolio records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_SALESORG_ID": {
            "type": "number"
        },
        "PORTFOLIO_ID": {
            "type": "string",
            "length": 50
        },
        "PORTFOLIO_NAME": {
            "type": "string",
            "length": 256
        },
        "PORTFOLIO_COMMENTS": {
            "type": "string",
            "length": 1333
        },
        "OVERLAP_HANDLING": {
            "type": "string",
            "length": 256
        },
        "CANNIBALIZATION_POLICY": {
            "type": "string",
            "length": 256
        },
        "METRIC_SET": {
            "type": "string",
            "length": 256
        },
        "WB_CUSTH_ID": {
            "type": "number"
        },
        "WB_PRDH_ID": {
            "type": "number"
        },
        "WB_PERIODH_ID": {
            "type": "number"
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1
        },
        "INTEGRATION_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    },
});
export const WB_Event_Portfolio_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Event_Portfolio_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolioRs'
        },
        [PASchema.esWB_Event_Portfolio_Customer_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'Customers'
        },
        [PASchema.esWB_Event_Portfolio_Product_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'Products'
        },
        [PASchema.esWB_Event_Portfolio_Period_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'Periods'
        },
        [PASchema.esWB_Event_Portfolio_Tag_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'Tags'
        },
        [PASchema.esWB_Event_Portfolio_EventType_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventTypes'
        },
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'LinkedAnalyses'
        }
    },
    belongsTo: {
        [PASchema.esWB_User]: {foreignKey: 'WB_AUTHUSR_ID_CREATEDBY', foreignKeyImmutable: true, localField: "UserCreatedBy"},
        [PASchema.esWB_SalesOrg]: {foreignKey: 'WB_SALESORG_ID', foreignKeyImmutable: true, localField: "SalesOrg"}
    }
};

export const WB_Event_Portfolio_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioR', // optional
    description: 'Schema for WB_Evt_PortfolioR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "ANALYSIS_TYPE": {
            "type": "string",
            "length": 50
        },
        "INTEGRATION_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1
        }
    },
});
export const WB_Event_Portfolio_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Event]: {
            foreignKey: 'WB_EVT_ID',
            foreignKeyImmutable: true,
            localField: 'Event'
        }
    }
};

//Portfolio Customer Relationship
export const WB_Event_Portfolio_Customer_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioCR', // optional
    description: 'Schema for WB_Evt_PortfolioCR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOCR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_CUST_ID": {
            "type": "number"
        },
        "BENCHMARK_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    },
});
export const WB_Event_Portfolio_Customer_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID',
            foreignKeyImmutable: true,
            localField: 'Customer'
        }
    }
};

//Portfolio Period Relationship
export const WB_Event_Portfolio_Period_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioTR', // optional
    description: 'Schema for WB_Evt_PortfolioTR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOTR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_PERIOD_ID": {
            "type": "number"
        },
        "BENCHMARK_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    },
});
export const WB_Event_Portfolio_Period_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Period]: {
            foreignKey: 'WB_PERIOD_ID',
            foreignKeyImmutable: true,
            localField: 'Period'
        }
    }
};

//Portfolio Product Relationship
export const WB_Event_Portfolio_Product_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioPR', // optional
    description: 'Schema for WB_Evt_PortfolioPR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOPR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "BENCHMARK_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    },
});
export const WB_Event_Portfolio_Product_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID',
            foreignKeyImmutable: true,
            localField: 'ProductGroup'
        }
    }
};


//Portfolio Tag Relationship
export const WB_Event_Portfolio_Tag_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioTGR', // optional
    description: 'Schema for WB_Evt_PortfolioTGR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOTGR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_TAG_ID": {
            "type": "number"
        },
        "BENCHMARK_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    },
});
export const WB_Event_Portfolio_Tag_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Tag]: {
            foreignKey: 'WB_TAG_ID',
            foreignKeyImmutable: true,
            localField: 'Tag'
        }
    }
};

//Portfolio EventType Relationship
export const WB_Event_Portfolio_EventType_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioETR', // optional
    description: 'Schema for WB_Evt_PortfolioETR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOETR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "WB_EVTTYPE_ID": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    },
});
export const WB_Event_Portfolio_EventType_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        },
        [PASchema.esWB_Event_Type]: {
            foreignKey: 'WB_EVTTYPE_ID',
            foreignKeyImmutable: true,
            localField: 'EventType'
        }
    }
};

//Portfolio Linked Analysis
export const WB_Event_Portfolio_LinkedAnalysis = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioLA', // optional
    description: 'Schema for WB_Evt_PortfolioLA records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOLA_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIO_ID": {
            "type": "number"
        },
        "LINKED_ANALYSIS_NAME": {
            "type": "string",
            "length": 256
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    },
});
export const WB_Event_Portfolio_LinkedAnalysis_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio]: {
            foreignKey: 'WB_EVT_PORTFOLIO_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolio'
        }
    },
    hasMany: {
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: {
            foreignKey: 'WB_EVT_PORTFOLIOLA_ID',
            foreignKeyImmutable: true,
            localField: 'Events'
        }
    }
};

//Portfolio Linked Analysis
export const WB_Event_Portfolio_LinkedAnalysis_Relationship = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_Evt_PortfolioLAR', // optional
    description: 'Schema for WB_Evt_PortfolioLAR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_EVT_PORTFOLIOLAR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_EVT_PORTFOLIOLA_ID": {
            "type": "number"
        },
        "WB_EVT_ID": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        }
    },
});
export const WB_Event_Portfolio_LinkedAnalysis_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: {
            foreignKey: 'WB_EVT_PORTFOLIOLA_ID',
            foreignKeyImmutable: true,
            localField: 'EventPortfolioLA'
        }
    }
};



// Dictionaries
//-- Schemas
_.defaults(dctSchemaByEntitySet,
    {
        [PASchema.esWB_Event_Portfolio]: WB_Event_Portfolio,
        [PASchema.esWB_Event_Portfolio_Relationship]: WB_Event_Portfolio_Relationship,
        [PASchema.esWB_Event_Portfolio_Customer_Relationship]: WB_Event_Portfolio_Customer_Relationship,
        [PASchema.esWB_Event_Portfolio_Product_Relationship]: WB_Event_Portfolio_Product_Relationship,
        [PASchema.esWB_Event_Portfolio_Period_Relationship]: WB_Event_Portfolio_Period_Relationship,
        [PASchema.esWB_Event_Portfolio_Tag_Relationship]: WB_Event_Portfolio_Tag_Relationship,
        [PASchema.esWB_Event_Portfolio_EventType_Relationship]: WB_Event_Portfolio_EventType_Relationship,
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: WB_Event_Portfolio_LinkedAnalysis,
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: WB_Event_Portfolio_LinkedAnalysis_Relationship
    });

//-- Table Names
_.defaults(dctTableNameByEntitySet,
    {
        [PASchema.esWB_Event_Portfolio]: "/AZR/WB_EVT_PORTFOLIO",
        [PASchema.esWB_Event_Portfolio_Relationship]: "/AZR/WB_EVT_PORTFOLIOR",
        [PASchema.esWB_Event_Portfolio_Customer_Relationship]: "/AZR/WB_EVT_PORTFOLIOCR",
        [PASchema.esWB_Event_Portfolio_Period_Relationship]: "/AZR/WB_EVT_PORTFOLIOTR",
        [PASchema.esWB_Event_Portfolio_Product_Relationship]: "/AZR/WB_EVT_PORTFOLIOPR",
        [PASchema.esWB_Event_Portfolio_Tag_Relationship]: "/AZR/WB_EVT_PORTFOLIOTGR",
        [PASchema.esWB_Event_Portfolio_EventType_Relationship]: "/AZR/WB_EVT_PORTFOLIOETR",
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: "/AZR/WB_EVT_PORTFOLIOLA",
        [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: "/AZR/WB_EVT_PORTFOLIOLAR"
    })

//-- Logical Key
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_Event_Portfolio]: [],
    [PASchema.esWB_Event_Portfolio_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_Customer_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_Product_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_Period_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_Tag_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_EventType_Relationship]: [],
    [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: [],
    [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: []
})

//-- Other Foreign Keys without jsData  Relationship
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_Event_Portfolio]: {},
    [PASchema.esWB_Event_Portfolio_Relationship]: {},
    [PASchema.esWB_Event_Portfolio_Relationship]: {},
    [PASchema.esWB_Event_Portfolio_Relationship]: {},
    [PASchema.esWB_Event_Portfolio_Relationship]: {},
    [PASchema.esWB_Event_Portfolio_Relationship]: {},
    [PASchema.esWB_Event_Portfolio_Relationship]: {},
})

//-- Key Pools
_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_Event_Portfolio]: {sequence_name: "/AZR/WB_EVT_PORTFOLIO_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_Event_Portfolio_Relationship]: {sequence_name: "/AZR/WB_EVT_PORTFOLIOR_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_Event_Portfolio_Customer_Relationship]: {sequence_name: "/AZR/WB_EVT_PORTFOLIOCR_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_Event_Portfolio_Period_Relationship]: {sequence_name: "/AZR/WB_EVT_PORTFOLIOTR_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_Event_Portfolio_Product_Relationship]: {sequence_name: "/AZR/WB_EVT_PORTFOLIOPR_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_Event_Portfolio_Tag_Relationship]: {sequence_name: "/AZR/WB_EVT_PORTFOLIOTGR_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_Event_Portfolio_EventType_Relationship]: {sequence_name: "/AZR/WB_EVT_PORTFOLIOETR_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_Event_Portfolio_LinkedAnalysis]: {sequence_name: "/AZR/WB_EVT_PORTFOLIOLA_SEQ", ...KeyGenSpecs_default},
    [PASchema.esWB_Event_Portfolio_LinkedAnalysis_Relationship]: {sequence_name: "/AZR/WB_EVT_PORTFOLIOLAR_SEQ", ...KeyGenSpecs_default},

})

// Add Section for Custom Columns if needed
